import AboutMe from "../AboutMe";
import Footer from "../Footer";
import MyPortfolio from "../MyPortfolio";

export default function Home () {
    return (
        <>
            <AboutMe />
            <MyPortfolio />
            <Footer />
        </>
    )
}